import React from 'react';

import './index.scss';

const QuestionMarkIcon = ()=> {
  return(
    <span className="q-circle">
      <span className="question">
        ？
      </span>
    </span>
  );
};

export default QuestionMarkIcon;